import React, { useState, useEffect } from 'react';

const FilterPanel = ({ allFlights, onFilter }) => {
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [maxPrice, setMaxPrice] = useState('');
  const [nonStopOnly, setNonStopOnly] = useState(false);
  const [showMobileFilter, setShowMobileFilter] = useState(false);

  const uniqueAirlines = [...new Set(allFlights.flatMap(flight => flight.flights.map(seg => seg.airline)))];

  const toggleAirline = (airline) => {
    setSelectedAirlines((prev) =>
      prev.includes(airline) ? prev.filter((a) => a !== airline) : [...prev, airline]
    );
  };

  const handleApply = () => {
    const filtered = allFlights.filter((result) => {
      const flightSegments = result.flights;

      const airlineMatch =
        selectedAirlines.length === 0 ||
        flightSegments.some((seg) => selectedAirlines.includes(seg.airline));

      const priceMatch = maxPrice === "" || result.price <= parseFloat(maxPrice);

      const nonStopMatch = nonStopOnly ? flightSegments.length === 1 : true;

      return airlineMatch && priceMatch && nonStopMatch;
    });

    onFilter(filtered);
  };

  return (
    <>
      {/* ======================= DESKTOP SIDEBAR ======================= */}
      <div className="hidden md:block w-64 p-4 h-full bg-[#0B1E34] text-white rounded-xl shadow-xl border border-[#16324C]">
        <h2 className="text-xl font-bold mb-4 tracking-wide text-[#E6F1F7]">Filters</h2>

        {/* Airlines */}
        <div className="mb-6">
          <label className="block font-semibold mb-2 text-sm text-[#9EC3E0]">Airlines</label>
          {uniqueAirlines.map((airline, index) => (
            <label key={index} className="flex items-center text-sm mb-2">
              <input
                type="checkbox"
                checked={selectedAirlines.includes(airline)}
                onChange={() => toggleAirline(airline)}
                className="mr-2 accent-orange-500"
              />
              {airline}
            </label>
          ))}
        </div>

        {/* Max Price */}
        <div className="mb-6">
          <label className="block font-semibold mb-2 text-sm text-[#9EC3E0]">Max Price ($)</label>
          <input
            type="number"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
            className="w-full p-2 bg-[#132F4C] text-white border border-[#234767] rounded-lg focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Non-stop */}
        <div className="mb-6 flex items-center">
          <input
            type="checkbox"
            checked={nonStopOnly}
            onChange={() => setNonStopOnly((prev) => !prev)}
            className="mr-2 accent-orange-500"
          />
          <label className="text-sm text-[#9EC3E0] font-medium">Non-stop only</label>
        </div>

        <button
          onClick={handleApply}
          className="w-full bg-gradient-to-r from-orange-500 to-pink-500 py-2 rounded-lg font-bold shadow-lg hover:scale-[1.03] transition"
        >
          Apply Filters
        </button>
      </div>

      {/* ======================= MOBILE BUTTON ======================= */}
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-[9999] md:hidden">
        <button
          onClick={() => setShowMobileFilter(true)}
          className="bg-gradient-to-r from-orange-500 to-pink-500 text-white px-8 py-3 rounded-full shadow-2xl font-semibold hover:scale-105 transition"
        >
          Filters ✨
        </button>
      </div>

      {/* ======================= MOBILE FILTER MODAL ======================= */}
      {showMobileFilter && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-[99999] flex items-end justify-center md:hidden backdrop-blur-sm">
          <div className="bg-white w-full rounded-t-2xl p-6 max-h-[80vh] overflow-y-auto shadow-2xl animate-slideUp">

            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filters</h2>
              <button
                onClick={() => setShowMobileFilter(false)}
                className="text-sm font-semibold text-blue-600"
              >
                Close ✕
              </button>
            </div>

            {/* Airlines */}
            <div className="mb-6">
              <label className="block font-semibold mb-1 text-gray-600">Airlines</label>
              <div className="grid grid-cols-2 gap-2">
                {uniqueAirlines.map((airline, index) => (
                  <label key={index} className="flex items-center text-sm">
                    <input
                      type="checkbox"
                      checked={selectedAirlines.includes(airline)}
                      onChange={() => toggleAirline(airline)}
                      className="mr-2 accent-orange-500"
                    />
                    {airline}
                  </label>
                ))}
              </div>
            </div>

            {/* Max Price */}
            <div className="mb-6">
              <label className="block font-semibold mb-1 text-gray-600">Max Price ($)</label>
              <input
                type="number"
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            {/* Non-stop */}
            <div className="mb-6 flex items-center">
              <input
                type="checkbox"
                checked={nonStopOnly}
                onChange={() => setNonStopOnly((prev) => !prev)}
                className="mr-2 accent-orange-500"
              />
              <label className="text-sm font-medium text-gray-700">Non-stop only</label>
            </div>

            {/* Apply Button */}
            <button
              onClick={handleApply}
              className="w-full bg-gradient-to-r from-orange-500 to-pink-500 text-white py-3 rounded-full font-bold shadow-md hover:scale-105 transition"
            >
              Apply Filters
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterPanel;
